import type {AppThunk} from '../../../../../actions/types'
import type {LoadedEndpoints} from '../../../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../../../routes/loadEndpoint'
import {restApi} from '../../../../../services/rest'
import type {BuildId} from '../../../../../types'

export const preloadFileTreeNodeExtension =
  ({endpoint, buildId}: {endpoint: string; buildId?: BuildId}): AppThunk<LoadedEndpoints> =>
  dispatch => [
    buildId != null &&
      dispatch(loadEndpoint(restApi.endpoints.getArtifactExtension, {buildId, endpoint})),
  ]
